var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 26.0078,
    cy: 26.3828,
    r: 26,
    fill: "#5D5B9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7957 40.8311C17.4904 40.8311 17.1976 40.7098 16.9817 40.494C16.7658 40.2781 16.6445 39.9853 16.6445 39.6799V14.3541C16.6446 14.1541 16.6967 13.9575 16.7959 13.7837C16.895 13.61 17.0377 13.4651 17.2099 13.3633C17.3821 13.2615 17.5779 13.2064 17.7779 13.2033C17.9779 13.2002 18.1753 13.2493 18.3506 13.3457L41.3741 26.0086C41.5546 26.108 41.7051 26.254 41.8099 26.4313C41.9147 26.6087 41.97 26.811 41.97 27.017C41.97 27.2231 41.9147 27.4253 41.8099 27.6027C41.7051 27.7801 41.5546 27.9261 41.3741 28.0255L18.3506 40.6884C18.1806 40.782 17.9897 40.8311 17.7957 40.8311Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.4b936239b901ea0069adde1046a41658.svg";
export { ForwardRef as ReactComponent };